import { ApprovalPolicyTemplate } from '../approval-workflow-policy';

// other...must always have another funding group
export const POLICY_TEMPLATE_OT: ApprovalPolicyTemplate = {
  fundingType: 'OT',
  stages: []
};
